import { render, staticRenderFns } from "./SubGrupoPlanoContas.vue?vue&type=template&id=54c457fe&"
import script from "./subGrupoPlanoContas.js?vue&type=script&lang=js&"
export * from "./subGrupoPlanoContas.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports